export default __webpack_public_path__ + "static/media/bottomlessbrunch2019.a709ed18.mp4";